unit NetNumberType;
{

/* Initail. */

}
interface

uses
  JS,
  SysUtils,
  LocationType, NetType, StatusType, UserType;

type
  TNetNumberType = class
  private
    fNetNumberKey: String;
    fNumber: String;
    fNet: TNetType;
    fLocation: TLocationType;
    fInfo: String;
    fWeigth: Single;
    fContainsLoanInstruments: Boolean;
    fStatus: TStatusType;
    fCreationDate: String;
    fCreatedBy: TUserType;
    fChangedDate: String;
    fChangedBy: TUserType;
    fActive: Boolean;
  public
    property NetNumberKey: String read fNetNumberKey;
    property Number: String read fNumber;
    property Net: TNetType read fNet;
    property Location: TLocationType read fLocation;
    property Info: String read fInfo;
    property Weigth: Single read fWeigth;
    property ContainsLoanInstruments: Boolean read fContainsLoanInstruments;
    property Status: TStatusType read fStatus;
    property CreationDate: String read fCreationDate;
    property CreatedBy: TUserType read fCreatedBy;
    property ChangedDate: String read fChangedDate;
    property ChangedBy: TUserType read fChangedBy;
    property Active: Boolean read fActive;
    constructor Create(const String_JSON: String);
    constructor CreateForRequest(const String_NetNumber: String);
  end;

implementation

constructor TNetNumberType.Create(const String_JSON: String);
var JSObject_Type: TJSObject;
begin
  JSObject_Type := TJSJSON.parseObject(String_JSON);

  fNetNumberKey := String(JSObject_Type['netNumberKey']);
  fNumber := String(JSObject_Type['number']);
  fNet := TNetType.Create(TJSJSON.stringify(JSObject_Type['net']));
  fLocation := TLocationType.Create(TJSJSON.stringify(JSObject_Type['location']));
  fInfo := String(JSObject_Type['info']);
  fWeigth := StrToFloatDef(String(JSObject_Type['weigth']), 0);
  fContainsLoanInstruments := (String(JSObject_Type['containsLoanInstruments']) = 'true');
  fStatus := TStatusType.Create(TJSJSON.stringify(JSObject_Type['status']));
  fCreationDate := String(JSObject_Type['creationDate']);
  fCreatedBy := TUserType.Create(TJSJSON.stringify(JSObject_Type['createdBy']));
  fChangedDate := String(JSObject_Type['changedDate']);
  fChangedBy := TUserType.Create(TJSJSON.stringify(JSObject_Type['changedBy']));
  fActive := (String(JSObject_Type['active']) = 'true');
end;

constructor TNetNumberType.CreateForRequest(const String_NetNumber: String);
begin
  fNumber := String_NetNumber;
end;

end.
